<template>
  <div class="container extend-page">
    <!-- 头部导航 -->
    <header-bar name="订单管理" />
    <!-- 筛选区域 -->
    <div class="filter-box">
      <div class="filter-item">
        <div class="filter-label">订单类型：</div>
        <select class="filter-select" v-model="filterType" @change="handleFilterChange">
          <option value="">全部</option>
          <option value="ACCOMPANY_DIAGNOSE">陪诊</option>
          <option value="BUY_MEDICINE">买药</option>
          <option value="INTERROGATION_DIAGNOSE">问诊</option>
          <option value="SEND_RESULTS">送取结果</option>
          <option value="OPEN_VIP">开通会员</option>
          <option value="RENEW">加时包</option>
          <option value="OPEN_VIP_YEAR">开通年会员</option>
          <option value="INTEREST_PACKAGE">权益套餐</option>
          <option value="GOODS">商品</option>
        </select>
      </div>
    </div>
    <!-- loading加载区域 -->
    <div class="loading-list" v-if="isLoading && arrOrder.length == 0">
      <van-loading type="spinner" />
    </div>
    <!-- 无数据 -->
    <empty text="目前暂无订单" v-if="arrOrder.length == 0 && isComplete" />
    <div class="list" v-if="arrOrder.length > 0">
      <div class="item" v-for="(item, index) in arrOrder" :key="index">
        <div class="base">
          <div class="code">订单号：{{ item.sn }}</div>
          <div class="status">{{ getOrderStatus(item.state) }}</div>
        </div>
        <div class="info">
          <div class="row">
            <div class="lab">下单人</div>
            <div class="inf">
              {{ item.sendUserName }} - {{ item.sendPhone }}
            </div>
          </div>
          <div class="row">
            <div class="lab">下单时间</div>
            <div class="inf">{{ item.createTime }}</div>
          </div>
          <div class="row" v-if="item.receivingUserName">
            <div class="lab">接单人</div>
            <div class="inf">
              {{ item.receivingUserName }} - {{ item.receivingPhone }}
            </div>
          </div>
          <div class="row" v-if="item.takeOrderTime">
            <div class="lab">接单时间</div>
            <div class="inf">{{ item.takeOrderTime }}</div>
          </div>
          <div class="row" v-if="item.type">
            <div class="lab">订单类型</div>
            <div class="inf">{{ getOrderType(item.type) }}</div>
          </div>
          <div class="row" v-if="item.productName">
            <div class="lab">商品名称</div>
            <div class="inf">{{ item.productName }}</div>
          </div>
          <div class="row">
            <div class="lab">订单金额</div>
            <div class="inf">¥{{ item.practicalPrice }}</div>
          </div>
          <div class="row" v-if="item.adCodeName">
            <div class="lab">所属地区</div>
            <div class="inf">{{ item.adCodeName }}</div>
          </div>
        </div>
        <div class="link">
          <div class="lnk-item lnk-default" :data-id="item.id" @click="handlerDetail">
            查看详情
          </div>
        </div>
      </div>
    </div>
    <!-- 触底 -->
    <loading-more
      v-show="isLoading && !isHadMore && arrOrder.length > 0"
      @doLoading="list"
      :isNoData="isHadMore"
      :isLoading="isLoading"
    />
  </div>
</template>

<script>
import HeaderBar from "components/HeaderBar/HeaderBar";
import Empty from "components/Empty/Empty";
import LoadingMore from "@/components/LoadingMore/LoadingMore";
import { passportUserInfo } from "@/api/login";
import { orderList } from "@/api/home";

export default {
  name: "OrderList",
  components: {
    HeaderBar,
    LoadingMore,
    Empty,
  },
  data() {
    return {
      arrOrder: [],
      isLoading: false,
      isHadMore: true,
      pageNumber: 1,
      pages: 999,
      isComplete: false,
      preventRepeatRequest: false,
      filterType: '', // 筛选的订单类型
    };
  },
  methods: {
    // 获取订单状态文本
    getOrderStatus: function (state) {
      const statusMap = {
        UNPAID: "未付款",
        PAID: "已付款",
        SERVE: "服务中",
        RECEIVING: "已接单",
        COMPLETED: "订单已完成",
        CANCEL: "已取消",
        REFUNDED: "已退款",
        OVER_TIME_PAY: "订单超时未支付",
        DELIVERED: "已发货",
        WAIT_DELIVER: "待发货",
        RECEIVED: "已收货",
      };
      return statusMap[state] || state || "未知状态";
    },

    // 获取订单类型文本
    getOrderType: function (type) {
      const typeMap = {
        ACCOMPANY_DIAGNOSE: "陪诊",
        BUY_MEDICINE: "买药",
        INTERROGATION_DIAGNOSE: "问诊",
        SEND_RESULTS: "送取结果",
        OPEN_VIP: "开通会员",
        RENEW: "加时包",
        OPEN_VIP_YEAR: "开通年会员",
        INTEREST_PACKAGE: "权益套餐",
        GOODS: "商品",
      };
      return typeMap[type] || type || "未知类型";
    },

    // 筛选变化处理
    handleFilterChange: function () {
      // 保存筛选状态到 localStorage
      if (this.filterType) {
        localStorage.setItem('orderFilterType', this.filterType);
      } else {
        localStorage.removeItem('orderFilterType');
      }
      // 重置分页和数据
      this.pageNumber = 1;
      this.arrOrder = [];
      this.pages = 999;
      this.isComplete = false;
      // 重新加载数据
      this.list();
    },

    // 查看详情
    handlerDetail: function (e) {
      let eId = e.currentTarget.dataset.id;
      // 保存筛选状态到 localStorage
      if (this.filterType) {
        localStorage.setItem('orderFilterType', this.filterType);
      } else {
        localStorage.removeItem('orderFilterType');
      }
      // 从列表中找到对应的订单项，传递下单人信息
      const orderItem = this.arrOrder.find(item => item.id === eId);
      const query = { id: eId };
      if (orderItem) {
        if (orderItem.sendUserName) query.sendUserName = orderItem.sendUserName;
        if (orderItem.sendPhone) query.sendPhone = orderItem.sendPhone;
      }
      this.$router.push({
        path: "/order-detail",
        query: query,
      });
    },

    // 加载订单列表
    list: function () {
      if (this.preventRepeatRequest) {
        this.preventRepeatRequest = false;
        return;
      }
      this.preventRepeatRequest = true;
      this.isLoading = true;

      // 首次加载时，确保 isComplete 为 false 以显示 loading
      if (this.arrOrder.length === 0) {
        this.isComplete = false;
      }

      if (this.pages + 1 == this.pageNumber && this.arrOrder.length > 0) {
        this.isHadMore = false;
        this.isLoading = false;
        this.isComplete = true;
        this.preventRepeatRequest = false;
        return;
      }

      if (this.pages + 1 == this.pageNumber) {
        this.isLoading = false;
        this.isComplete = true;
        this.preventRepeatRequest = false;
        return;
      }

      // 调用订单列表API
      const params = {
        pageNumber: this.pageNumber,
        size: 10,
        sort: 'createTime',
        order: 'desc',
      };
      // 如果选择了订单类型筛选，添加type参数
      if (this.filterType) {
        params.type = this.filterType;
      }
      orderList(params).then((res) => {
        this.isLoading = false;
        if (res) {
          const records = res.records || [];
          this.arrOrder.push(...records);
          this.pageNumber++;
          this.pages = res.pages || 0;
        }
        this.isComplete = true;
        this.preventRepeatRequest = false;
      }).catch(() => {
        this.isLoading = false;
        this.isComplete = true;
        this.preventRepeatRequest = false;
      });
    },
  },
  mounted: function () {
    this.pageNumber = 1;
    this.arrOrder = [];
    this.isLoading = true;
    this.isHadMore = true;
    this.pages = 999;
    this.isComplete = false;
    // 从 localStorage 恢复筛选类型
    const savedFilterType = localStorage.getItem('orderFilterType');
    if (savedFilterType) {
      this.filterType = savedFilterType;
    }
    passportUserInfo().then((res) => {
      this.list();
    });
  },
};
</script>

<style scoped>
.filter-box {
  padding: 0.2rem;
  background: #fff;
  margin-bottom: 0.2rem;
}
.filter-item {
  display: flex;
  align-items: center;
}
.filter-label {
  font-size: 0.28rem;
  color: #333;
  margin-right: 0.2rem;
}
.filter-select {
  flex: 1;
  height: 0.64rem;
  padding: 0 0.2rem;
  border: 1px solid #d9d9d9;
  border-radius: 0.12rem;
  font-size: 0.28rem;
  color: #333;
  background: #fff;
}
.loading-list {
  padding: 0.4rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list {
  padding: 0 0.2rem;
}
.list > .item {
  position: relative;
  background: #fff;
  border-radius: 0.2rem;
  margin: 0.2rem 0 0;
  padding: 0 0.2rem 0.2rem;
}
.list > .item > .base {
  font-size: 0.28rem;
  height: 0.88rem;
  line-height: 0.88rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list > .item > .base > .code {
  color: #333;
  font-weight: 600;
}
.list > .item > .base > .status {
  color: #1890ff;
  font-size: 0.26rem;
}
.list > .item > .info {
  position: relative;
  padding: 0.2rem 0;
}
.list > .item > .info::before,
.list > .item > .info::after {
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  height: 1px;
  background: #e1e1e1;
}
.list > .item > .info::before {
  top: 0;
}
.list > .item > .info::after {
  bottom: 0;
}
.list > .item > .info > .row {
  height: 0.56rem;
  line-height: 0.56rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list > .item > .info > .row > .lab {
  color: #999;
}
.list > .item > .info > .row > .inf {
  color: #555;
}
.list > .item > .link {
  padding: 0.2rem 0 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
}
.list > .item > .link > .lnk-item {
  height: 0.6rem;
  line-height: 0.6rem;
  padding: 0 0.24rem;
  margin: 0 0 0 0.16rem;
  border-radius: 0.12rem;
}
.list > .item > .link > .lnk-default {
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #666;
}
</style>

